import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
// import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import debounce from 'lodash/debounce';
import CardClient from "../../components/CardClient.vue";
import Header from "../../components/Header.vue";
import YearComponent from "../../components/YearComponent.vue";
import {fetchYears} from "../../utils/fetchYears";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)


export default {
    components: {
        YearComponent,
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin,
        CardClient
    },
    data: function () {
        return {
            pageTitle: "Liste des tresoreries",
            client_list: [],
            filter: {
                search: '',
                year: '',
            },
            current_page: 1,
            per_page: 18,
            last_page: 1,
            sort: "nom_client|asc",
            listYear: []
        }
    },
    computed: {

    },
    methods: {
        selectYear(year){
            this.filter.year = year;
            this.setFilter();
            this.$refs.yearComponent.closeModalYear();
        },
        setFilter() {
            this.fetchClientList();
        },
        resetFilter() {
            this.filter={
                search: '',
                year: '',
            }

            this.setFilter();
        },
        async fetchYear() {
            const response = await fetchYears({ that: this, link: '/dossier/fetchyear' })
            this.listYear = response.data;
            this.filter.year = response.data && response.data.length ? response.data[0].annee : null;
            await this.fetchClientList()
        },
        fetchClientList() {
            axios
                .get(this.BASE_URL + "/client/fetchall", {
                    params: {
                        page: this.current_page,
                        per_page: this.per_page,
                        filter: this.filter.search,
                        year: this.filter.year,
                        sort: this.sort
                    }
                })
                .then(res => {
                    this.client_list = res.data.data;
                    this.current_page = parseInt(res.data.current_page);
                    this.last_page = parseInt(res.data.last_page);
                })
                .catch(err => console.error(err));
        },

        changePage(page) {
            if (page < 1 || page > this.last_page) return;
            this.current_page = page;
            this.fetchClientList();
        },

        selectClient(clientId) {
            // console.log("Client sélectionné :", clientId);
            this.$router.push("/dossier/client/"+clientId+"/"+this.filter.year);
        },
        // Debounced input
        onFilterInput: debounce(function() {
            this.current_page = 1;
            this.fetchClientList();
        }, 500)
    },

    created: function () {
        this.$emit('change-page', this.pageTitle);
        this.motCle = "";
        this.criteriacol = "";

    },
    mounted:async function () {
        await this.fetchYear();

    }
}
